import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const VibrantWhitePinkInBlue = ({
  svgProps,
  hideGrain,
}: {
  svgProps: React.SVGProps<SVGSVGElement>
  hideGrain?: boolean
}) => {
  const uniqueId = useId()
  const maskId = `grainMask-vibrant-white-pink-in-blue-${uniqueId}`

  return (
    <svg
      {...svgProps}
      width="1972"
      height="2073"
      viewBox="0 0 1972 2073"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          id="filter0_f_5717_4084"
          x="0"
          y="0"
          width="200%"
          height="200%"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_5717_4084"
          />
        </filter>
        <filter
          id="filter1_f_5717_4084"
          x="0"
          y="0"
          width="200%"
          height="200%"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_5717_4084"
          />
        </filter>
        <filter
          id="filter2_f_5717_4084"
          x="0"
          y="0"
          width="200%"
          height="200%"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_5717_4084"
          />
        </filter>

        <mask id={maskId}>
          <rect width="100%" height="100%" fill="black" />
          <g filter="url(#filter0_f_5717_4084)">
            <ellipse
              cx="986"
              cy="1158.03"
              rx="475.718"
              ry="467.647"
              transform="rotate(-30.7308 986 1158.03)"
              fill="white"
            />
          </g>
          <g filter="url(#filter1_f_5717_4084)">
            <ellipse
              cx="986"
              cy="868.026"
              rx="441.76"
              ry="434.265"
              transform="rotate(-30.7308 986 868.026)"
              fill="white"
            />
          </g>
          <g filter="url(#filter2_f_5717_4084)">
            <ellipse
              cx="986"
              cy="898.026"
              rx="441.76"
              ry="434.265"
              transform="rotate(-30.7308 986 898.026)"
              fill="white"
            />
          </g>
        </mask>
      </defs>

      <g filter="url(#filter0_f_5717_4084)">
        <ellipse
          cx="986"
          cy="1158.03"
          rx="475.718"
          ry="467.647"
          transform="rotate(-30.7308 986 1158.03)"
          fill="#176AE5"
        />
      </g>
      <g filter="url(#filter1_f_5717_4084)">
        <ellipse
          cx="986"
          cy="868.026"
          rx="441.76"
          ry="434.265"
          transform="rotate(-30.7308 986 868.026)"
          fill="#EF91F7"
        />
      </g>
      <g filter="url(#filter2_f_5717_4084)">
        <ellipse
          cx="986"
          cy="898.026"
          rx="441.76"
          ry="434.265"
          transform="rotate(-30.7308 986 898.026)"
          fill="#FFD2E1"
        />
      </g>

      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${maskId})`}
          opacity={0.9}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
